import RentMonthlyCostsFields from '../forms/RentMonthlyCostsFields';
import { filterNumericInput } from '../../utils/submissions';
import ListingDetailsToggle from './ListingDetailsToggle';

const AdminSubmissionExtrasFields = ({ form, setForm, sub, update }) => (
  <div className="admin-submission-extras">
    <div className="admin-submission-extras__flags">
      <ListingDetailsToggle
        label="Renovation"
        value={form.renovationNeeded}
        onChange={(val) => update('renovationNeeded', val)}
        id={`admin-sub-renovation-${sub.id}`}
      />
      {form.renovationNeeded === 'yes' ? (
        <label className="admin-submission-content__field admin-submission-content__field--inline admin-submission-extras__cost-inline">
          <span>Est. cost</span>
          <input
            type="text"
            inputMode="decimal"
            placeholder="$"
            value={form.renovationCost}
            onChange={(e) => update('renovationCost', filterNumericInput(e.target.value, { decimal: true }))}
          />
        </label>
      ) : null}
      <ListingDetailsToggle
        label="Land banking"
        value={form.landBanking}
        onChange={(val) => update('landBanking', val)}
        id={`admin-sub-land-banking-${sub.id}`}
      />
    </div>
    {form.renovationNeeded === 'yes' ? (
      <label className="admin-submission-content__field admin-submission-extras__notes">
        <span>Renovation notes</span>
        <input
          type="text"
          placeholder="Brief scope or timeline"
          value={form.renovationDesc}
          onChange={(e) => update('renovationDesc', e.target.value)}
        />
      </label>
    ) : null}
    <div className="admin-submission-extras__costs">
      <div className="admin-submission-extras__costs-head">
        <span>Monthly cost breakdown</span>
      </div>
      <RentMonthlyCostsFields
        form={form}
        setForm={setForm}
        idPrefix={`admin-sub-rent-${sub.id}`}
        variant="compact"
      />
    </div>
  </div>
);

export default AdminSubmissionExtrasFields;
